import * as angular from 'angular';
import * as d3 from 'd3';

import { ComponentDefinition, Group, IdentifierType } from '../../models';
import { IGroupService } from '../../services';
import { guidEmpty, groupSelected } from '../../common';

class GroupsTreeController implements angular.IComponentController {
    groups: Group[];
    isLoading: boolean;
    loadingMessage: string;

    private _padding = 20;
    private _selectedGroup;

    static $inject = [
        '$rootScope',
        'groupService'
    ];

    constructor(
        private _$rootScope: angular.IRootScopeService,
        private _groupService: IGroupService
    ) {
    }

    $onInit() {
        this.loadGroups();
    }
    
    loadGroups() {
        this.isLoading = true;
        this._groupService
            .getAll()
            .then((response) => {
                const groups = response.map(d => d.group);
                const tree = {
                    name: 'root',
                    children: groups.filter(g => g.parentGUID === guidEmpty)
                };
                tree.children.forEach((c: any) => {
                    c.children = this.getChildren(groups, c.guid);
                });
                const hierarchy = (<any>d3.layout.hierarchy())(tree);
                this.groups = hierarchy;
            })
            .finally(() => this.isLoading = false);
    }

    private getChildren(groups: Group[], guid: string): Group[] {
        const children = groups.filter(g => g.parentGUID === guid);
        if (children.length > 0) {
            children.forEach((c: any) => {
                c.children = this.getChildren(groups, c.guid);
            });
        }
        return children;
    }

    getPadding(group: any) {
        let style = {};
        if (group.depth !== 0) {
            style = {
                'padding-left': (group.depth * this._padding) + 'px'
            };
        }
        return style;
    }

    isSelected(guid: string) {
        return this._selectedGroup && guid === this._selectedGroup.guid;
    }

    select(group: Group) {
        if (group) {
            this._selectedGroup = group;
            this._$rootScope.$broadcast(groupSelected, group);
        }
    }

    tagsCount(group) {
        return group.identifierCollection ? group.identifierCollection.filter(d => (d.type === IdentifierType.Tag)).length : 0;
    }

    calculatedCount(group) {
        return group.identifierCollection ? group.identifierCollection.filter(d => (d.type === IdentifierType.CalculatedValue)).length : 0;
    }

    linkedCount(group) {
        return group.identifierCollection ? group.identifierCollection.filter(d => (d.type === IdentifierType.Linked)).length : 0;
    }
}

export const wtGroupsTree: ComponentDefinition = {
    componentId: 'wtGroupsTree',
    controller: GroupsTreeController,
    template: require('./groupsTree.component.html'),
    controllerAs: 'vm',
    bindings: {
    }
};
